export default __webpack_public_path__ + "static/media/boomerang_logo.f66411fb.svg";